import { __awaiter, __generator, __read, __spread } from "tslib";
import { logDebugCacheEvent } from '@office-start/instrumentation-service';
import { IDLE_LOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { APP_WORKLOAD, APP_WORKLOAD_TYPE, AUDIENCE_GROUP, BROWSER_SESSION_ID, DATA_BOUNDARY, DEPLOYMENT_ENV, DEVICE_TYPE, DOMAIN_ORIGIN, ECS_RING, EVENT_SCHEMA_VERSION, FIRST_VISIT_AGE_IN_DAYS, FLIGHTS, INITIAL_PAGE_NAME, IS_ADMIN, IS_DYNAMICS, IS_EDU, IS_EDU_FACULTY, IS_EDU_STUDENT, IS_FIRST_VISIT, IS_IW, IS_SMB, NETWORK_TYPE, RELEASE, REQUEST_ORIGIN, SCHEMA_VERSION, SERVER_LOCATION, SERVICE_WORKER_STATE, USER_SEGMENT, } from '@office-start/telemetry-types';
import { EventQueue, getFlattenedFieldName, isGuid, } from '@office-start/telemetry-utility';
import { addUnloadEvent } from '@office-start/unload-utility';
var App;
var Session;
var User;
var DataCategories;
var DiagnosticLevel;
var loggerEnabled = false;
var LogLevel;
var loggerInitialized = false;
var nameSpace = '';
var SamplingPolicy;
var samplerModule;
var telemetryLogger;
var telemetryLoggerModule;
var unAuthLoggerEnabled = false;
var unAuthLoggerInitialized = false;
var unAuthTelemetryLogger;
var unAuthOneDsSink;
var makeBooleanDataField;
var makeInt64DataField;
var makeStringDataField;
var makeDoubleDataField;
var oneDsSinkModule;
var oneDsEndpointModule;
var oneDsSink;
var onNotification;
var osPlugin;
var persistentFields;
var suppressNexus;
var eventQueue = new EventQueue();
var unAuthEventQueue = new EventQueue();
var oneDsSinkPromiseResolver;
export var authOneDsSinkPromise = new Promise(function (resolve) {
    oneDsSinkPromiseResolver = resolve;
});
/**
 * Function to delay-load OTELJS and initialize anonymous OTelTelemetry logger.
 *
 * TODO: Add tests, validation of event field and anonymous OTelTelemetry logger initialization
 *
 */
export function initializeUnAuthOTel(config) {
    if (!(config.oTelEnabled && config.oTelAriaTenant) ||
        !isValidConfig(config.correlationId, config.sessionId) ||
        unAuthLoggerInitialized) {
        return Promise.resolve();
    }
    unAuthLoggerEnabled = true;
    nameSpace = config.oTelAriaNameSpace;
    return Promise.all([downloadOTel(), downloadOneDs()])
        .then(function () {
        unAuthTelemetryLogger = new telemetryLoggerModule(undefined, undefined, {
            enableQueue: true,
        });
        unAuthTelemetryLogger.setTenantToken(config.oTelAriaNameSpace, config.oTelAriaTenant, suppressNexus);
        persistentFields = getPartAFields(config.appName, config.appPlatform, config.appWorkload, config.bundleBuildDate, config.correlationId, config.deploymentEnvironment, config.deviceType, config.flights, config.isCorpNet, config.isTestTraffic, config.sessionId, config.serverLocation, config.requestOrigin, true, // isAnonymous
        undefined, undefined);
        // TODO: Add Privacy Guard to oneDsSink https://www.owiki.ms/wiki/Telemetry/Privacy/Privacy_Guard
        if (config.win11DetectionEnabled) {
            getSinkOsPlugin().then(function (sinkOsPlugin) {
                unAuthOneDsSink = new oneDsSinkModule(persistentFields, {
                    endpointUrl: getOneDsEndpoint(config.deploymentEnvironment),
                    plugins: [sinkOsPlugin],
                });
            });
        }
        else {
            unAuthOneDsSink = new oneDsSinkModule(persistentFields, {
                endpointUrl: getOneDsEndpoint(config.deploymentEnvironment),
            });
        }
        unAuthTelemetryLogger.addSink(unAuthOneDsSink);
        unAuthLoggerInitialized = true;
        drainQueuedEvents(true);
    })
        .catch(function () {
        // logger initialization failed, set loggerEnabled to false to prevent buffering events to queue
        unAuthLoggerEnabled = false;
    });
}
/**
 * Function to delay-load OTELJS and initialize non-anonymous OTelTelemetry logger.
 *
 * TODO: Add tests, validation of event field and anonymous OTelTelemetry logger initialization
 *
 */
export function initializeOTel(config) {
    if (!(config.oTelEnabled && config.oTelAriaTenant) ||
        !isValidConfig(config.correlationId, config.sessionId, config.identity.tenantId) ||
        loggerInitialized) {
        return Promise.resolve();
    }
    loggerEnabled = true;
    nameSpace = config.oTelAriaNameSpace;
    return Promise.all([
        downloadOTel(config.schedulerPriority),
        downloadOneDs(config.schedulerPriority),
    ])
        .then(function () {
        telemetryLogger = new telemetryLoggerModule(undefined, undefined, {
            enableQueue: config.win11DetectionEnabled,
        });
        telemetryLogger.setTenantToken(config.oTelAriaNameSpace, config.oTelAriaTenant, suppressNexus);
        persistentFields = getPartAFields(config.appName, config.appPlatform, config.appWorkload, config.bundleBuildDate, config.correlationId, config.deploymentEnvironment, config.deviceType, config.flights, config.isCorpNet, config.isTestTraffic, config.sessionId, config.serverLocation, config.requestOrigin, false, // authenticated
        config.identity, config.userSegment, config.ecsRing, config.appWorkloadType, config.networkType, config.serviceWorkerState, config.firstVisitAgeInDays, config.domainOrigin, config.initialPageName, config.dataBoundary);
        // TODO: Add Privacy Guard to oneDsSink https://www.owiki.ms/wiki/Telemetry/Privacy/Privacy_Guard
        if (config.win11DetectionEnabled) {
            getSinkOsPlugin().then(function (sinkOsPlugin) {
                oneDsSink = new oneDsSinkModule(persistentFields, {
                    endpointUrl: getOneDsEndpoint(config.deploymentEnvironment, config.dataBoundary, config.IsEudbEndpointEnabled),
                    plugins: [sinkOsPlugin],
                });
                oneDsSinkPromiseResolver(oneDsSink);
                setUpSampler(config.IsSamplingEnabled, config.identity.puid, config.correlationId);
                telemetryLogger.addSink(oneDsSink);
                loggerInitialized = true;
                drainQueuedEvents(false);
                addUnloadEvent(function () {
                    endSession(false);
                }, true);
            });
        }
        else {
            oneDsSink = new oneDsSinkModule(persistentFields, {
                endpointUrl: getOneDsEndpoint(config.deploymentEnvironment, config.dataBoundary, config.IsEudbEndpointEnabled),
            });
            oneDsSinkPromiseResolver(oneDsSink);
            setUpSampler(config.IsSamplingEnabled, config.identity.puid, config.correlationId);
            telemetryLogger.addSink(oneDsSink);
            loggerInitialized = true;
            drainQueuedEvents(false);
            addUnloadEvent(function () {
                endSession(false);
            }, true);
        }
    })
        .catch(function () {
        // logger initialization failed, set loggerEnabled to false to prevent buffering events to queue
        loggerEnabled = false;
    });
}
function downloadOTel(schedulerPriority) {
    return new Promise(function (resolve, reject) {
        scheduleWork(function () {
            import(/* webpackChunkName: "oteljs" */ '@microsoft/oteljs')
                .then(function (oteljs) {
                App = oteljs.App;
                Session = oteljs.Session;
                User = oteljs.User;
                makeBooleanDataField = oteljs.makeBooleanDataField;
                makeInt64DataField = oteljs.makeInt64DataField;
                makeStringDataField = oteljs.makeStringDataField;
                makeDoubleDataField = oteljs.makeDoubleDataField;
                telemetryLoggerModule = oteljs.TelemetryLogger;
                suppressNexus = oteljs.SuppressNexus;
                onNotification = oteljs.onNotification;
                onNotification().addListener(function (event) {
                    if (event.level === 0 /* Error */) {
                        console.log(event.message());
                        try {
                            var params = {};
                            params["Error" /* Error */] = event.message();
                            logDebugCacheEvent('OtelNotificationErrorEvent', params);
                        }
                        catch (e) {
                            console.log(e);
                        }
                    }
                });
                resolve();
            })
                .catch(function (err) {
                reject(err);
            });
        }, schedulerPriority !== null && schedulerPriority !== void 0 ? schedulerPriority : IDLE_LOW_PRIORITY);
    });
}
function downloadOneDs(schedulerPriority) {
    return new Promise(function (resolve, reject) {
        scheduleWork(function () {
            import(/* webpackChunkName: "oteljs1ds" */ '@microsoft/oteljs-1ds')
                .then(function (_a) {
                var OneDSEndpoint = _a.OneDSEndpoint, OneDSSink = _a.OneDSSink, OsPlugin = _a.OsPlugin, Sampler = _a.Sampler;
                oneDsSinkModule = OneDSSink;
                oneDsEndpointModule = OneDSEndpoint;
                osPlugin = OsPlugin;
                samplerModule = Sampler;
                resolve();
            })
                .catch(function (err) {
                reject(err);
            });
        }, schedulerPriority !== null && schedulerPriority !== void 0 ? schedulerPriority : IDLE_LOW_PRIORITY);
    });
}
function getSinkOsPlugin() {
    return __awaiter(this, void 0, void 0, function () {
        var plugin;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    plugin = new osPlugin();
                    return [4 /*yield*/, plugin.detectOs()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, plugin];
            }
        });
    });
}
function setUpSampler(isSamplingEnabled, userId, sessionId) {
    /*
     * Events with the event flag SamplingPolicy.Measure can be sampled, generally to help control telemetry costs.
     * In Office Online, events are sampled at 0.02 on User.PrimaryIdentityHash, with Session.Id as a fallback, using the djb2 algorithm. We recommend using the same setup as Office Online.
     */
    if (isSamplingEnabled) {
        var sampler = new samplerModule();
        if (userId) {
            sampler.enableWithIdentifier('PrimaryIdentityHash', userId);
        }
        else {
            sampler.enableWithIdentifier('SessionId', sessionId);
        }
        var samplingRate = 0.02;
        sampler.setSampleRate(samplingRate);
        oneDsSink.addPreprocessor(sampler);
    }
}
/**
 * Function used to either send the event immediately when the telemetry logger is available
 * or buffer it until the telemetry logger is ready
 *
 * @param eventName Event name, used to construct fully qualified name
 * @param properties Additional data properties for event
 *
 */
export function sendEvent(eventName, properties, isSampled) {
    sendEventCommon(eventName, properties, false, isSampled);
}
/**
 * Function used to either send the event immediately when the anonymous telemetry logger is available
 * or buffer it until the telemetry logger is ready
 *
 * @param eventName Event name, used to construct fully qualified name
 * @param properties Additional data properties for event
 *
 */
export function sendUnAuthEvent(eventName, properties, isSampled) {
    sendEventCommon(eventName, properties, true, isSampled);
}
function sendEventCommon(eventName, properties, isAnonymous, isSampled) {
    if (isAnonymous ? !unAuthLoggerEnabled : !loggerEnabled) {
        return;
    }
    if (isAnonymous ? unAuthLoggerInitialized : loggerInitialized) {
        // Event.Name: Office.Taos.Hub.<eventName> Event name follows a hierarchical name matching the tenant's name
        var fullyQualifiedName = [nameSpace, eventName].join('.');
        // Part C fields: Different for each event category
        //   - EventCategory
        //   - <EventCategory>Details (PageViewDetails.PageName, PageViewDetails.PageType, PageViewDetails.IsIntentional)
        var dataFields = convertToDataFields(properties);
        sendTelemetryEvent(isAnonymous ? unAuthTelemetryLogger : telemetryLogger, fullyQualifiedName, dataFields, 2 /* ProductServiceUsage */, 110 /* RequiredServiceData */, isSampled ? 1 /* Measure */ : 0 /* NotSet */);
    }
    else {
        var event_1 = {
            eventName: eventName,
            params: properties,
            isSampled: isSampled,
        };
        isAnonymous
            ? unAuthEventQueue.queueEvent(event_1)
            : eventQueue.queueEvent(event_1);
    }
}
function sendTelemetryEvent(logger, eventName, dataFields, dataCategories, diagnosticLevel, samplingPolicy) {
    logger.sendTelemetryEvent({
        eventName: eventName,
        dataFields: dataFields,
        eventFlags: {
            dataCategories: dataCategories,
            diagnosticLevel: diagnosticLevel,
            samplingPolicy: samplingPolicy,
        },
    });
}
/**
 *  Function to generate telemetry fields to be sent on every event.
 *  Part A fields: common fields, these fields should be set on the 1DS sink and cannot be changed
 *    - Required Part A: Fields are required for events that can be processed in COSMOS (App, Session and User)
 *         - App (App.Platform, App.Name)
 *         - Session (Session.Id): use correlationId as primary id
 *         - User (User.IsAnonymous, User.PrimaryIdentityHash, User.PrimaryIdentitySpace, User.TenantGroup, User.TenantId)
 *         - Release (Release.AudienceGroup)
 *    - Customize Part A:
 *         - EventSchemaVersion
 *         - RequestOrigin
 *         - SessionId
 *         - UserSegment (UserSegment.IsAdmin, UserSegment.IsDynamics, UserSegment.IsEdu, UserSegment.IsEduFaculty, UserSegment.IsEduStudent, UserSegment.IsFirstVisit, UserSegment.IsIw, UserSegment.IsSmb)
 */
export function getPartAFields(appName, appPlatform, appWorkload, bundleBuildDate, correlationId, deploymentEnvironment, deviceType, flights, isCorpNet, isTestTraffic, sessionId, serverLocation, requestOrigin, isAnonymous, identity, userSegment, ecsRing, appWorkloadType, networkType, serviceWorkerState, firstVisitAgeInDays, domainOrigin, initialPageName, dataBoundary) {
    // version : in format yyyymmd.x
    // TODO: Figure out a way to generate the version number
    var VERSION = '0';
    var buildDate = bundleBuildDate.split(' ')[0].split('-').join('');
    var appVersion = [buildDate, VERSION].join('.');
    var requiredPartADataFields = __spread(App.getFields({
        platform: appPlatform,
        name: appName,
        version: appVersion,
    }), Session.getFields({
        id: correlationId,
    }), [
        makeStringDataField(getFlattenedFieldName([RELEASE, AUDIENCE_GROUP]), getReleaseAudienceGroup(deploymentEnvironment, isCorpNet, isTestTraffic)),
        makeStringDataField(DEPLOYMENT_ENV, deploymentEnvironment),
    ]);
    if (isAnonymous) {
        requiredPartADataFields.push.apply(requiredPartADataFields, __spread(User.getFields({
            isAnonymous: true,
        })));
    }
    else {
        var puid = identity === null || identity === void 0 ? void 0 : identity.puid;
        var idSpace = '';
        if (puid) {
            idSpace = (identity === null || identity === void 0 ? void 0 : identity.isMsa) ? 'MsaPuid' : 'OrgIdPuid';
        }
        requiredPartADataFields.push.apply(requiredPartADataFields, __spread(User.getFields({
            primaryIdentityHash: puid,
            primaryIdentitySpace: idSpace,
            tenantId: identity === null || identity === void 0 ? void 0 : identity.tenantId,
            tenantGroup: (identity === null || identity === void 0 ? void 0 : identity.isMsa) ? 'Consumer' : 'Commercial',
            isAnonymous: false,
        })));
    }
    var customPartADataFields = [
        makeStringDataField(EVENT_SCHEMA_VERSION, SCHEMA_VERSION),
        makeStringDataField(REQUEST_ORIGIN, requestOrigin),
        makeStringDataField(BROWSER_SESSION_ID, sessionId),
        makeStringDataField(APP_WORKLOAD, appWorkload),
        makeStringDataField(SERVER_LOCATION, serverLocation),
        makeStringDataField(DEVICE_TYPE, deviceType),
    ];
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isAdmin) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_ADMIN]), userSegment.isAdmin));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isDynamics) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_DYNAMICS]), userSegment.isDynamics));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isEdu) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_EDU]), userSegment.isEdu));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isEduFaculty) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_EDU_FACULTY]), userSegment.isEduFaculty));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isEduStudent) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_EDU_STUDENT]), userSegment.isEduStudent));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isFirstVisit) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_FIRST_VISIT]), userSegment.isFirstVisit));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isIw) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_IW]), userSegment.isIw));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isSmb) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_SMB]), userSegment.isSmb));
    }
    if (flights) {
        customPartADataFields.push(makeStringDataField(FLIGHTS, flights));
    }
    if (appWorkloadType) {
        customPartADataFields.push(makeStringDataField(APP_WORKLOAD_TYPE, appWorkloadType));
    }
    if (ecsRing) {
        customPartADataFields.push(makeStringDataField(ECS_RING, ecsRing));
    }
    if (networkType) {
        customPartADataFields.push(makeStringDataField(NETWORK_TYPE, networkType));
    }
    if (serviceWorkerState) {
        customPartADataFields.push(makeStringDataField(SERVICE_WORKER_STATE, serviceWorkerState));
    }
    if (firstVisitAgeInDays) {
        customPartADataFields.push(makeInt64DataField(FIRST_VISIT_AGE_IN_DAYS, firstVisitAgeInDays));
    }
    if (domainOrigin) {
        customPartADataFields.push(makeStringDataField(DOMAIN_ORIGIN, domainOrigin));
    }
    if (initialPageName) {
        customPartADataFields.push(makeStringDataField(INITIAL_PAGE_NAME, initialPageName));
    }
    if (dataBoundary) {
        customPartADataFields.push(makeStringDataField(DATA_BOUNDARY, dataBoundary));
    }
    var partADataFields = __spread(requiredPartADataFields, customPartADataFields);
    return partADataFields;
}
function getOneDsEndpoint(deploymentEnvironment, dataBoundary, IsEudbEndpointEnabled) {
    if (dataBoundary === 'EU' && IsEudbEndpointEnabled) {
        return oneDsEndpointModule.EUDB;
    }
    switch (deploymentEnvironment) {
        case "pfprod" /* PFProd */:
            return oneDsEndpointModule.USGOV_DOD;
        case "tbprod" /* TBProd */:
            return oneDsEndpointModule.USGOV_DOJ;
        default:
            return oneDsEndpointModule.PUBLIC;
    }
}
export function getReleaseAudienceGroup(deploymentEnvironment, isCorpNet, isTestTraffic) {
    if (isTestTraffic) {
        return 'Automation';
    }
    switch (deploymentEnvironment) {
        case "dev" /* Dev */:
        case "ppe" /* PPE */:
        case "prodprv" /* ProdPrv */:
            return 'Automation';
        case "prod" /* Prod */:
        case "bfprod" /* BFProd */:
        case "pfprod" /* PFProd */:
        case "tbprod" /* TBProd */:
        case "unprod" /* UNProd */:
        case "usprod" /* USProd */:
            if (isCorpNet) {
                return 'Microsoft';
            }
            return 'Production';
        default:
            return 'Automation';
    }
}
// Function to flush the queue, used after OTelLogger is initialized.
function drainQueuedEvents(isAnonymous) {
    var queuedEvents;
    if (isAnonymous) {
        queuedEvents = unAuthEventQueue.drainQueue();
        queuedEvents.forEach(function (event) {
            if (event.eventName) {
                sendUnAuthEvent(event.eventName, event.params || {});
            }
        });
    }
    else {
        queuedEvents = eventQueue.drainQueue();
        queuedEvents.forEach(function (event) {
            if (event.eventName) {
                sendEvent(event.eventName, event.params || {});
            }
        });
    }
}
/**
 * Helper function to help convert the defined telemetry fields to the OTEL DataFields.
 *
 * @param data - Additional properties for event
 */
function convertToDataFields(data) {
    return Object.keys(data)
        .filter(function (key) {
        return typeof data[key] == 'number' ||
            typeof data[key] == 'boolean' ||
            typeof data[key] == 'string';
    })
        .map(function (key) {
        var value = data[key];
        if (typeof value === 'boolean') {
            return makeBooleanDataField(key, value);
        }
        else if (typeof value === 'number') {
            if (Number.isInteger(value)) {
                return makeInt64DataField(key, value);
            }
            else {
                return makeDoubleDataField(key, value);
            }
        }
        return makeStringDataField(key, value);
    });
}
export function isValidConfig(correlationId, sessionId, tenantId) {
    if (tenantId) {
        return isGuid(correlationId) && isGuid(sessionId) && isGuid(tenantId);
    }
    return isGuid(correlationId) && isGuid(sessionId);
}
export function endSession(isAnonymous) {
    if (isAnonymous
        ? !(unAuthLoggerEnabled && unAuthLoggerInitialized)
        : !(loggerEnabled && loggerInitialized)) {
        return;
    }
    drainQueuedEvents(isAnonymous);
    try {
        var logger = isAnonymous ? unAuthTelemetryLogger : telemetryLogger;
        logger.telemetrySinks.forEach(function (sink) {
            var _a, _b;
            (_b = (_a = sink).flush) === null || _b === void 0 ? void 0 : _b.call(_a, false);
        });
    }
    catch (e) {
        console.log(e);
    }
}
//# sourceMappingURL=OtelTelemetryService.js.map